export enum Category {
  ALL = 'all',
  MODELS = 'models',
  PROJECTS = 'projects',
  PLATFORMS = 'platforms',
  CONTENT = 'content',
  COMMUNITY = 'community',
  OTHER = 'other'
}

export type Language = 'en' | 'zh';

export type PublishStatus = 'draft' | 'pending_review' | 'published' | 'rejected';

export interface Resource {
  id: string;
  title: string;
  title_zh?: string;
  description: string;
  description_zh?: string;
  category: Category;
  category_l1?: string;
  category_l2?: string;
  category_confidence?: number;
  category_source?: 'manual' | 'rule' | 'ai';
  url: string;
  icon?: string; // Emoji or URL
  tags: string[];
  featured?: boolean;
  visibility?: 'public' | 'private' | 'team';
  team_name?: string;
  owner_id?: string;
  team_id?: string;
  publish_status?: PublishStatus;
  review_note?: string;
  reviewed_by?: string;
  reviewed_at?: string;
  submitted_at?: string;
  created_at?: string;
  updated_at?: string;
  view_count?: number;
  favorite_count?: number;
  source?: string;
  source_meta?: Record<string, unknown>;
}

export interface SearchResult {
  resource: Resource;
  score: number;
}
